import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, Subscription } from 'rxjs';
import { ControlsModule } from 'segov-sigepo-lib';
import { Arquivo, ConteudoConfiguravel, MenuItem } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/controls/segov-sigepo-side-menu-with-body/segov-sigepo-side-menu-with-body.component';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { PerguntaFrequenteInputDto } from 'src/app/domain/DTOs/input/perguntas-frequentes.input.dto';
import { PerguntaFrequenteOutputDto } from 'src/app/domain/DTOs/output/pergunta-frequente.output.dto';
import { listarPerguntasFrequentes, listarPerguntasFrequentesFinish } from 'src/app/stateManagement/actions/perguntas-frequentes.action';
import { ListarPerguntasFrequentesState } from 'src/app/stateManagement/reducers/perguntas-frequentes.reducer';
import { selectDadosListarPerguntasFrequentes } from 'src/app/stateManagement/selectors/perguntas-frequentes.selector';
import { CommonMessages } from 'src/app/utils/common.messages';
import { ComponentMessages } from 'src/app/utils/component.messages';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { ObterArquivoServicoState } from 'src/app/stateManagement/reducers/Servicos/obter-arquivo-servico-jornal.reducer';
import { obterArquivoServico, obterArquivoServicoFinish } from 'src/app/stateManagement/actions/Servicos/obter-arquivo-servico-jornal.action';
import { StringUtils } from 'src/app/utils/string.utils';
import { saveAs } from 'file-saver-es';
import { selectDadosObterArquivoServico } from 'src/app/stateManagement/selectors/Servicos/obter-arquivo-servico-jornal.selector';

@Component({
  selector: 'app-segov-sigepo-perguntas-frequentes-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    ControlsModule
  ],
  templateUrl: './perguntas-frequentes-page.component.html'
})
export class PerguntasFrequentesPageComponent implements OnInit, OnDestroy {
  public title = ComponentMessages.centralDeRelacionamento;
  public ItemsMenuPerguntasFrequentes: MenuItem[] | undefined = undefined;
  public errorMsg = '';
  public efetouPesquisa = false;
  public reiniciouPesquisa = false;
  public totalRegistros?: number;
  public apagarTexto = new EventEmitter<void>();
  public finalizouNovaPesquisa = new EventEmitter<void>();

  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Atendimento", route: SegovPage.Atendimento },
    { title: "Perguntas frequentes", route: SegovPage.PerguntasFrequentes }
  ]

  private InputPesquisa = '';
  private tituloArquivo = '';
  private subListarPerguntasFrequentes: Subscription;
  private subObterArquivo: Subscription;

  constructor(
    private readonly storeListarPerguntasFrequentes: Store<{ listarPerguntasFrequentesState: ListarPerguntasFrequentesState }>,
    private readonly storeObterArquivoServico: Store<{ obterArquivoState: ObterArquivoServicoState }>,
    private router: Router) {
    this.subListarPerguntasFrequentes = new Subscription();
    this.subObterArquivo = new Subscription();
  }

  ngOnInit(): void {
    this.subListarPerguntasFrequentes = this.storeListarPerguntasFrequentes.select(selectDadosListarPerguntasFrequentes)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.ItemsMenuPerguntasFrequentes = this.groupPerguntasFrequentes(response?.dados ?? []);
        if (this.InputPesquisa) {
          this.efetouPesquisa = true;
          this.totalRegistros = response?.dados?.length;
        }
        if (this.reiniciouPesquisa) {
          this.efetouPesquisa = false;
          this.totalRegistros = undefined;
        }
        setTimeout(() => {
          this.finalizouNovaPesquisa.emit();
        }, 50)
      });

    this.subObterArquivo = this.storeObterArquivoServico.select(selectDadosObterArquivoServico)
      .subscribe(result => {
        this.baixarArquivo(result?.dados);
      });

    this.ReiniciarPesquisa();
  }

  ngOnDestroy(): void {
    this.subListarPerguntasFrequentes.unsubscribe();
    this.subObterArquivo.unsubscribe();
    this.storeListarPerguntasFrequentes.dispatch(listarPerguntasFrequentesFinish());
    this.storeObterArquivoServico.dispatch(obterArquivoServicoFinish());
  }

  public AtualizaTexto(event: string) {
    if (event.length < 3 && event.length > 0) {
      this.errorMsg = CommonMessages.LimiteMinimoPesquisa;
    } else {
      this.errorMsg = '';
    }
    this.InputPesquisa = event;
  }

  public goToAtendimento() {
    this.router.navigate([SegovPage.Atendimento]);
  }

  public PesquisarPerguntasFrequentes() {
    this.reiniciouPesquisa = false;
    if (!this.errorMsg)
      this.getListarPerguntasFrequentes(new PerguntaFrequenteInputDto(this.InputPesquisa));
  }

  public ReiniciarPesquisa() {
    this.reiniciouPesquisa = true;
    this.getListarPerguntasFrequentes(new PerguntaFrequenteInputDto(''));
    this.InputPesquisa = '';
    this.errorMsg = '';
    this.apagarTexto.emit();
  }

  public scrollToIdByResolution(event: string) {
    ScreenUtils.scrollToIdByResolution(event, 993);
  }

  private getListarPerguntasFrequentes(inputDto: PerguntaFrequenteInputDto) {
    this.efetouPesquisa = false;
    this.storeListarPerguntasFrequentes.dispatch(listarPerguntasFrequentes({ perguntasFrequentesInputDto: inputDto }))
  }

  private groupPerguntasFrequentes(
    perguntas: PerguntaFrequenteOutputDto[]
  ): MenuItem[] {
    const menuItemsMap: Record<string, MenuItem> = {};

    perguntas.forEach(pergunta => {
      const tipoPerguntaDescricao = pergunta.categoriaPerguntaFrequente.tipoPerguntaDescricao;
      const nomeCategoria = pergunta.categoriaPerguntaFrequente.nome;

      if (!menuItemsMap[tipoPerguntaDescricao]) {
        menuItemsMap[tipoPerguntaDescricao] = {
          topic: "Dúvidas " + tipoPerguntaDescricao.toLowerCase(),
          subtopics: []
        };
      }

      let subTopic = menuItemsMap[tipoPerguntaDescricao].subtopics.find(
        st => st.name === nomeCategoria
      );

      if (!subTopic) {
        subTopic = {
          name: nomeCategoria,
          titleAndContent: []
        };
        menuItemsMap[tipoPerguntaDescricao].subtopics.push(subTopic);
      }

      subTopic.titleAndContent.push({
        title: `${pergunta.pergunta}`,
        respostas: pergunta.resposta.map((x) => {
          return {
            texto: x.texto,
            naoPularLinha: x.naoPularLinha,
            linkURL: x.linkURL,
            arquivo: x.arquivo
          } as ConteudoConfiguravel
        }),
        respostasEmLista: pergunta.respostasEmLista?.map((x) => {
          return {
            texto: x.texto,
            naoPularLinha: x.naoPularLinha,
            linkURL: x.linkURL,
            arquivo: x.arquivo
          } as ConteudoConfiguravel
        }),
        respostasEmListaComTitulo: pergunta.respostasEmListaComTitulo?.map((x) => {
          return {
            titulo: x.titulo,
            respostas: x.descricoes?.map((x) => {
              return {
                texto: x.texto,
                naoPularLinha: x.naoPularLinha,
                linkURL: x.linkURL,
                arquivo: x.arquivo
              } as ConteudoConfiguravel
            })
          }
        })
      });
    });

    Object.values(menuItemsMap).forEach(menuItem => {
      menuItem.subtopics.sort((a, b) => a.name.localeCompare(b.name));
    });

    return Object.values(menuItemsMap);
  }

  private baixarArquivo(base64?: string) {
    if (base64) {
      const download = StringUtils.PrepareFileToDownload(base64);
      saveAs(download.file, `${this.tituloArquivo}.${download.extension}`);
    }
  }

  public baixarArquivoSelecionado(arquivo: Arquivo): void {
    this.tituloArquivo = arquivo.titulo;
    const nomeArquivo = arquivo.nomeArquivo;
    this.storeObterArquivoServico.dispatch(obterArquivoServico({ nomeArquivo }));
    this.storeObterArquivoServico.dispatch(obterArquivoServicoFinish());
  } 
}
